import React, { useRef, useState } from 'react';
import { motion, useInView } from "framer-motion";

import './services.css';

function Services() {
  const [activeTab, setActiveTab] = useState('engineering');

  const creativeServices = [
    'التصور البصري للمشاريع (3D، رندر، VR/AR)',
    'تطوير الهوية البصرية للمشاريع والعلامات التجارية',
    'تصميم الغرافيك: (الشعارات, البروشورات, العروض التقديمية، اللوحات الإعلانية)',
    'إنتاج فيديوهات دعائية وعروض معمارية ترويجية',
  ];

  const engineeringServices = [
    'التصميم المعماري الداخلي والخارجي',
    'إعداد المخططات التنفيذية التفصيلية',
    'دراسات الجدوى الفنية والهندسية',
    'الإشراف على التنفيذ وإدارة المشاريع',
    'أعمال البناء والتشييد والتطوير العقاري',
    'الاستشارات الهندسية المتخصصة',
  ];

  const currentServices = activeTab === 'creative' ? creativeServices : engineeringServices;


  const servicesCard = useRef(null);
  const servicesCardView = useInView(servicesCard, {
    triggerOnce: true,
    margin: '400px 0px', // ✅ يزيد مدى الرؤية من الأعلى
  });
  

  return (
    <section className="servicesSection ">
      <div className='container'>

        {/* التبويبات */}
        <div className="tabs mb-4 d-flex justify-content-center" ref={servicesCard}>
          <button
            className={`tab-btn ${activeTab === 'engineering' ? 'active' : ''}`}
            onClick={() => setActiveTab('engineering')}
          >
            خدمات الهندسة والتنفيذ
          </button>
          <button
            className={`tab-btn ${activeTab === 'creative' ? 'active' : ''}`}
            onClick={() => setActiveTab('creative')}
          >
            خدمات التصميم الإبداعي
          </button>

        </div>

        {/* المحتوى */}
        <div className="row justify-content-center gy-4">
          {currentServices.map((service, index) => (
            <div className="col-md-5 col-sm-12" key={index}>
              <motion.p
                key={`${activeTab}-${index}`} // ✅ يعيد التحريك عند تغيير التاب
                initial={{ opacity: 0, x: 100 }}
                animate={servicesCardView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
              >
                <div className={`serviceCard ${index === currentServices.length - 1 ? 'last-card' : ''}`}>
                  {service}
                </div>
              </motion.p>
            </div>
          ))}

        </div>

      </div>
    </section >
  );
}

export default Services;
